export const COLORS = {
  white: '#fafafa',
  green: '#26e815',
  blue: '#2081e2',
  black: '#121212',
  gray: '#707a83',
  lightBlack: '#303236',
  boxShadow: '#27282b',
  boxShadowHover: '#303236',
}